import {
  formatStockNoPolicyLabel,
} from '#/modules/imsMgmt/receipts/stockTransfer/helper/transferStatus';

function formatWarehouseLocation(warehouse) {
  if (!warehouse) {
    return '-';
  }

  const location = warehouse.location;
  const warehouseLabel = warehouse.code
    ? `${warehouse.code} ${warehouse.name ?? ''}`.trim()
    : (warehouse.name ?? '-');

  if (!location) {
    return warehouseLabel;
  }

  const locationLabel = location.code
    ? `${location.code} ${location.name ?? ''}`.trim()
    : (location.name ?? '-');

  return `${warehouseLabel} → ${locationLabel}`;
}

function formatLocation(location) {
  if (!location) {
    return '-';
  }

  const locationLabel = location.code
    ? `${location.code} ${location.name ?? ''}`.trim()
    : (location.name ?? '-');

  return locationLabel || '-';
}

function formatUnitLabel(unit) {
  if (!unit) {
    return '-';
  }
  return [unit.code, unit.name].filter(Boolean).join(' ') || '-';
}

export function buildStockTransferLineColumns({ showCompletedFields = false } = {}) {
  const columns = [
    {
      id: 'stockNo',
      header: '來源庫存',
      size: 140,
      enableSorting: false,
      cell: ({ row }) => row.original.sourceInvStock?.stockNo
        || row.original.sourceInvStock?.id
        || '-',
    },
    ...(showCompletedFields ? [{
      id: 'transferred',
      header: '轉出庫存',
      size: 120,
      enableSorting: false,
      cell: ({ row }) => row.original.transferredInvStock?.stockNo || '-',
    }] : []),
    {
      id: 'mtr',
      header: '物料',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => {
        const mtr = row.original.mtr;
        if (!mtr) {
          return '-';
        }
        return (
          <div>
            <p>{mtr.name || '-'}</p>
            <p className="text-xs font-mono text-gray-500">{mtr.mtrNo || ''}</p>
          </div>
        );
      },
    },
    {
      id: 'qty',
      header: '數量',
      size: 100,
      enableSorting: false,
      meta: { cellClassName: 'text-right' },
      cell: ({ row }) => {
        const qty = row.original.qty;
        if (qty == null) {
          return '-';
        }
        return String(qty);
      },
    },
    {
      id: 'unit',
      header: '單位',
      size: 88,
      enableSorting: false,
      cell: ({ row }) => formatUnitLabel(row.original.unit),
    },
    {
      id: 'from',
      header: '來源倉／儲位',
      size: 180,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => formatWarehouseLocation(row.original.fromWarehouse),
    },
    {
      id: 'toLocation',
      header: '儲位',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => formatLocation(row.original.toLocation),
    },
    {
      id: 'stockNoPolicy',
      header: '庫編設定',
      minSize: 200,
      enableSorting: false,
      cell: ({ row }) => formatStockNoPolicyLabel(row.original.stockNoPolicy),
    },
    {
      id: 'remark',
      header: '備註',
      size: 140,
      enableSorting: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => row.original.remark || '-',
    },
  ];

  if (showCompletedFields) {
    columns.push(
      {
        id: 'remaining',
        header: '剩餘庫存',
        size: 120,
        enableSorting: false,
        cell: ({ row }) => row.original.remainingInvStock?.stockNo || '-',
      },
      {
        id: 'txCount',
        header: '異動筆數',
        size: 88,
        enableSorting: false,
        meta: { cellClassName: 'text-right' },
        cell: ({ row }) => (row.original.invTransactions ?? []).length,
      },
    );
  }

  return columns;
}
